import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));

const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('NG0912')) {
    console.group('🚨 COLISIÓN DE COMPONENTE DETECTADA (NG0912)');
    console.error('Origen de la duplicidad:');
    console.trace(); // Esto imprimirá la ruta de archivos que cargó el componente
    console.groupEnd();
  }
  originalWarn.apply(console, args);
};
